export default function Opinion() {
  const bullets = [
    '診断コンテンツ（チェックリスト）を置く：問い合わせの心理ハードルが下がる',
    'FAQ/事例を増やす：決断材料が増え、CVRが上がる',
    '「症状別LP」を作る：キーワードごとに刺さり方が変わるため'
  ];

  return (
    <section id="opinion" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-[1000px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            別の意見（広告より先に"仕組み化"）
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            広告は短期には効きますが、長期は「検索→納得→問い合わせ」の資産が勝ちます。
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <ul className="space-y-5">
            {bullets.map((item, index) => (
              <li key={index} className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-lightbulb-line text-gray-900 text-2xl"></i>
                </div>
                <span className="text-base md:text-lg text-gray-700 leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
